import styled from "styled-components";
import theme from "~/styles/theme";

export const TooltipContainer = styled.div<{ showTooltip: boolean }>`
    position: relative;

    .tooltip-content {
        padding: 0.8rem;
        background: #1d1d1d;
        padding: 7px;
        border-radius: 5px;
        position: absolute;
        display: ${({ showTooltip }) => (showTooltip ? "block" : "none")} !important;
        text-align: center;
        left: -1.2rem;
        top: -2.5rem;
        border: 1px solid #1d1d1d;

        &:before {
            content: "";
            height: 3px;
            width: 0;
            border: 7px solid transparent;
            border-top-color: #1d1d1d;
            position: absolute;
            bottom: -16px;
            left: 1.4rem;
        }
        .msg {
            p {
                color: #fff;
                max-width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                margin: 0;
                padding: 0rem 0.2rem;
            }

            &:hover {
                p {
                    color: ${theme.color.primary.background};
                }
            }
        }
    }
`;

export const RatingContainer = styled.div<{ direction: string; spaceContent: boolean }>`
    padding: 0 !important;
    span {
        color: ${theme.color.primary.background};
        font-size: 1.7rem;

        svg {
            width: 1.7rem;
        }
    }

    .rating {
        display: flex;
        align-items: center;
        justify-content: ${({ spaceContent }) => (spaceContent ? "space-between" : "")};
        flex-direction: ${({ direction }) => direction};
        padding: 0;

        div,
        span {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0;
        }

        button {
            background: transparent;
            cursor: pointer;
            width: 1.7rem;
        }

        p {
            color: ${theme.color.terciary.accent};
            margin-right: 0.7rem;
        }

        span {
            margin: 0 0.1rem;
        }
    }

    @media (max-width: 720px) {
        .rating {
            justify-content: space-between;
        }
    }
`;
